// https://vuex.vuejs.org/en/mutations.html
import * as TYPES from './mutation-types'

/* eslint-disable no-param-reassign */
export default {
    [TYPES.CAMPAING_CHECKED_SETTINGS] (state, checkedSettings) {
        state.checkedSettings = checkedSettings
    },
}


// WEBPACK FOOTER //
// ./src/app/adobeAcrobat/vuex/mutations.js